<template>
    <view-with-bar>
        <template slot="bar">
            <view-bar>
                <template v-for="operationDefinitionGroup in operationDefinitionGroups">
                    <h1 @click="groupVisibility[operationDefinitionGroup.systemName] = !groupVisibility[operationDefinitionGroup.systemName]">
                        <icon :icon="['fal', groupVisibility[operationDefinitionGroup.systemName] ? 'caret-down' : 'caret-right']"/>&nbsp;{{operationDefinitionGroup.displayName}}
                    </h1>
                    <template v-if="groupVisibility[operationDefinitionGroup.systemName]">
                        <view-bar-item :route="`/operations/by-definition/${definition}`"
                                       v-for="definition in operationDefinitionGroup.operationDefinitions">
                            {{operationDefinitions.find(def => def.id == definition).name}}
                        </view-bar-item>
                    </template>
                </template>
<!--                <h1 @click="groupVisibility.all = !groupVisibility.all">-->
<!--                    <icon :icon="['fal', groupVisibility.all ? 'caret-down' : 'caret-right']"/>&nbsp;All types-->
<!--                </h1>-->
<!--                <template v-if="groupVisibility.all">-->
<!--                    <view-bar-item :route="`/operations/by-definition/${definition.id}`"-->
<!--                                   v-for="definition in operationDefinitions">{{definition.name}}-->
<!--                    </view-bar-item>-->
<!--                </template>-->
<!--                <h1>Links</h1>-->
<!--                <view-bar-item route="/operations/links">-->
<!--                    Operation links-->
<!--                </view-bar-item>-->
            </view-bar>
        </template>
    </view-with-bar>
</template>

<script>
    import ViewWithBar from "../components/layout/ViewWithBar";
    import ViewBar from "../components/navigation/ViewBar";
    import {mapGetters} from "vuex";
    import ViewBarItem from "../components/navigation/ViewBarItem";

    export default {
        name: "OperationsView",
        components: {ViewBarItem, ViewBar, ViewWithBar},
        data: function () {
            return {
                groupVisibility: {
                    'all': false
                }
            }
        },
        mounted() {
            this.operationDefinitionGroups.forEach(group => this.$set(this.groupVisibility, group.systemName, true));
        },
        computed: {
            ...mapGetters({
                operationDefinitions: "operationDefinitions/operationDefinitions",
                operationDefinitionGroups: "operationDefinitionGroups/operationDefinitionGroups"
            })
        },
    }
</script>

<style lang="scss" scoped>
    h1 {
        cursor: pointer;
    }
</style>